export default {
    methods: {
        hasSlotContent: function(slotName = 'default') {
            // double negation will result in:
            // - body is object: !!{} = !false = true
            // - body is null: !!null = !true = false
            return !!this.$slots[slotName];
        },
        hasScopedSlotContent: function(slotName = 'default') {
            return !!this.$scopedSlots[slotName];
        },
    },

    computed: {
        hasHeaderContent: function() {
            return this.hasSlotContent('header');
        },
        hasBodyContent: function() {
            return this.hasSlotContent('body');
        },
        hasFooterContent: function() {
            return this.hasSlotContent('footer');
        },
        hasCellContent: function() {
            return this.hasScopedSlotContent('cell');
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/mixins/OptionalSlotsMixin.js